import React, { useEffect, Tabs, Tab, useReducer} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Map from './map';
import $ from 'jquery';
// import Email from 'smtpjs'

const Oakgrandeurii = () => {
    useEffect(() =>{
        document.title = "Earth VIII Oak Grandeur II"
    },[])

    // TABS
    class Tabs extends React.Component{
        state ={
          activeTab: this.props.children[0].props.label
        }
        changeTab = (tab) => {
      
          this.setState({ activeTab: tab });
        };
        render(){
          
          let content;
          let buttons = [];
          return (
            <div>
              {React.Children.map(this.props.children, child =>{
                buttons.push(child.props.label)
                if (child.props.label === this.state.activeTab) content = child.props.children
              })}
               
              <TabButtons activeTab={this.state.activeTab} buttons={buttons} changeTab={this.changeTab}/>
              <div className="tab-content">{content}</div>
              
            </div>
          );
        }
      }
      
      const TabButtons = ({buttons, changeTab, activeTab}) =>{
         
        return(
            <div className="tab-buttons">
            {buttons.map(button =>{
               return <button className={ button === activeTab? 'tabactive': ''} onClick={()=>changeTab(button)}>{button}</button>
            })}
            </div>
          
        )
      }
      
      const Tab = props =>{
        return(
          <React.Fragment>
            {props.children}
          </React.Fragment>
        )
      }
       
// TABS


// Pay

    const submitFunction = () =>{

        var settingsmailchimp = {
      "url":"https://api.rich-oak.com/api/mailchimp/10536edd08",
          "method": "POST",
          "timeout": 0,
          "data":
          {
            "mailchimp":{ "email_address":document.getElementById("email").value,  "status":"subscribed",
            "merge_fields": {
        "FNAME": document.getElementById("name").value ,
        "LNAME": "" 
    }
          }
        }

        };

        $.ajax(settingsmailchimp).done(function (response) {
        //   console.log(response);
        })
        
        var name = document.getElementById("name").value
        var email = document.getElementById("email").value
        var phone = document.getElementById("phone").value
        var address = document.getElementById("address").value
        var nok = document.getElementById("nok").value

        var nokaddress = document.getElementById("nokaddress").value
        var nokphone = document.getElementById("nokphone").value 
        var nokemail = document.getElementById("nokemail").value 
        var nokrelationship = document.getElementById("nokrelationship").value 

        var bank = document.getElementById("bank").value 
        var accountname = document.getElementById("accountname").value 
        var accountnumber = document.getElementById("accountnumber").value 



        var units= document.getElementById("UnitDropdownId").value
        var amount = units * 500000
        localStorage.setItem("ogname", name);
        localStorage.setItem("ogemail", email);
        localStorage.setItem("ogphone", phone);
        localStorage.setItem("ogaddress", address);
        localStorage.setItem("nok", nok);
        localStorage.setItem("nokaddress", nokaddress);
        localStorage.setItem("nokphone", nokphone);
        localStorage.setItem("nokemail", nokemail);
        localStorage.setItem("nokrelationship", nokrelationship);
        localStorage.setItem("ogunits", units);
        localStorage.setItem("amount", amount);

        if(name ==="" ){
            
            document.getElementById("err").innerHTML = "Input Your Fullname In The Form Above"
            $(".err").css({'display': 'block'});
        }

        else if( email==="" ){
            document.getElementById("err").innerHTML = "Input Your E-mail Address In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(phone==="" ){
            document.getElementById("err").innerHTML = "Input Your Phone Number In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(address==="" ){
            document.getElementById("err").innerHTML = "Input Your Address In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(nok==="" ){
            document.getElementById("err").innerHTML = "Input Your Next of Kin`s Name In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(nokaddress==="" ){
            document.getElementById("err").innerHTML = "Input Your Next of Kin`s Address In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(nokphone==="" ){
            document.getElementById("err").innerHTML = "Input Your Next of Kin`s Phone Number In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(nokemail==="" ){
            document.getElementById("err").innerHTML = "Input Your Next of Kin`s E-mail In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(nokrelationship==="" ){
            document.getElementById("err").innerHTML = "Input Your Next of Kin`s Relationship To You In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(bank==="" ){
            document.getElementById("err").innerHTML = "Input Your Bank Name In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(accountname==="" ){
            document.getElementById("err").innerHTML = "Input Your Account Name In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }

        else if(accountnumber==="" ){
            document.getElementById("err").innerHTML = "Input Your Account Number In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }




        else if(units==="" ){
            document.getElementById("err").innerHTML = "Select Number of Units In The Form Above"

            $(".err").css({'display': 'block'});
            // document.getElementById("err").innerHTML = "Fill in Missing Field(s)"
        }
        else{
            document.getElementById("err").innerHTML = "Submitting"


            
        window.Email.send({
          Host : "smtp.mailgun.org",
    Username : "postmaster@rich-oak.com",
    Password : "4331aec46913e5025416b4669ae5fe65-7b8c9ba8-b7fbbae4",
    // To:'aalexandra@rich-oak.com, uvictora@rich-oak.com',
        To:'apeace@rich-oak.com, orebecca@rich-oak.com',
        // To:'aayo@rich-oak.com',
    From : "info@rich-oak.com",
    Subject : "Oak Grandeur II",
    Body :  document.getElementById("name").value + " "
    + document.getElementById("email").value +" "
    + document.getElementById("phone").value + " "
    + document.getElementById("address").value + " "
    + document.getElementById("nok").value + " "
    + document.getElementById("nokaddress").value + " "
     +  document.getElementById("nokphone").value + " "
      +  document.getElementById("nokemail").value + " "
      + document.getElementById("nokrelationship").value + " "
      + document.getElementById("bank").value + " "
      + document.getElementById("accountname").value + " "
      + document.getElementById("accountnumber").value + " "
    + document.getElementById("UnitDropdownId").value + " Investment Unit(s)",


    }).then(function(){
      document.getElementById("err").innerHTML = "Submitting"
        $('.ajax-loader').css("visibility", "hidden");
        // console.log("ff")
        var clientname = document.getElementById("name").value;
        // document.getElementById('clientname').innerHTML = name 
        var settings = {
      beforeSend: function(){
      
  },
      "url": "https://api.rich-oak.com/api/reifcertificates",
      "method": "POST",
      "timeout": 0,
    //   "headers": { "Authorization": "Bearer " + localStorage.getItem("access_token") },
//       complete: function(){
//     $('.ajax-loader').css("visibility", "hidden");
//   },
      "data": {
        "reifcertificate": {
           "investor_fullname": document.getElementById("name").value , 
           "investor_address": document.getElementById("address").value , 
           "next_of_kin_name": document.getElementById("nok").value , 
           "next_of_kin_address": document.getElementById("nokaddress").value , 
           "next_of_kin_phone": document.getElementById("nokphone").value , 
           "next_of_kin_email": document.getElementById("nokemail").value , 
           "next_of_kin_relationship": document.getElementById("nokrelationship").value , 
           "bank": document.getElementById("bank").value , 
           "accountname": document.getElementById("accountname").value , 
           "accountnumber": document.getElementById("accountnumber").value , 

           "email": document.getElementById("email").value , 
           "investment_sum": localStorage.getItem("amount"),
           "investment_units": document.getElementById("UnitDropdownId").value,
           "roi_schedule": "Unapproved",
           "source": "Transfer"

        }
      }
    }
        $.ajax(settings).done(function (response) {
console.log(response)
        })
        document.getElementById("err").innerHTML = "Submitted Successfully, Your investment certificate will be sent to you shortly"
        window.location.replace("/oakgrandeurii");


    })



    }
}


// SHOW PAYMENT OPTIONS
// const showPaystack = () => {
//   $(".aftersuccess").fadeIn();
//   $(".paystackbutton").css({'display': 'block'});
//   $(".transferbutton").css({'display': 'none'});
//   document.getElementById("paymenttitleoption").innerHTML = "PAY WITH PAYSTACK"
// }

// const showTransfer = () => {
//   $(".aftersuccess").fadeIn();
//   $(".paystackbutton").css({'display': 'none'});
//   $(".transferbutton").css({'display': 'block'});
//   document.getElementById("paymenttitleoption").innerHTML = "PAY VIA BANK TRANSFER"

// }
// SHOW PAYMENT OPTIONS
    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>

<div  class="apartmentsfirstbox">
<div class="container">
<div class="row">
<div class="col-md-6">
    <h1 className="homesherotitle">Oak Grandeur II
       
    </h1>
 
</div>

<div class="col-md-6">
<p className="ogherosubtitle fordesktoponly">
    Oak-Grandeur II is an exclusive, beautiful and serene apartment, built on 650sqm area of land and located in a secure and developed area of Jahi-Abuja. The distance from this location to Central area of Abuja is approximately 10 Minutes, with diplomats, middle income earners and business executives as residents of the surrounding area.          </p>
    
         <p className="ogherosubtitle formobileonly">
         Oak-Grandeur II is an exclusive, beautiful and serene apartment, built on 650sqm area of land and located in a secure and developed area of Jahi-Abuja. The distance from this location to Central area of Abuja is approximately 10 Minutes, with diplomats, middle income earners and business executives as residents of the surrounding area.          </p>
 

        <p><a style={{textDecoration:"none", color:"#666666", fontWeight:"bold"}} href="#features">View house features <img className="" src="images/rightarrow.png"/></a></p>

    </div>

    </div>
    </div>
</div>


<Map/>

<div class="container ">
<div class="row og2tabs">
    {/* <div class="col-md-4">
    <div style={{paddingBottom:"30px"}} class="row">
               <div class="col-md-1 col-2">
                   <img style={{paddingTop:"30px" }} className="" src="images/line.png"/>

                   </div>
                   <div class="col-md-11 col-10"  style={{paddingLeft:"25px" }}>
                   <h2 className=" hmsecondboxtitle hmsecondboxtitlesmscreen fordesktoponly">  Indepth information on <br/>Oak Grandeur II</h2>
                   <h2 className=" hmsecondboxtitle formobileonly">  Indepth information on Oak Grandeur II.</h2>

                   </div>
               
<img src="images/oakgrandeur2/frame2.jpeg"/>
           </div>
    </div> */}
    <div class="col-md-12">
    <div  >
    <div className='container'>
       <div class="row">
         



           <div class="col-md-12">
           <div class="row mobilerow">
               
           <div className="tabs">

       <Tabs>

         <Tab label="Features">
           <div id="features">
             <p style={{textAlign:"justify", paddingBottom:"30px"}} className="hmseconddescription">Oak Grandeur 2 is a 650sqm area of land located in a secure, serene and developed area of Jahi-Abuja. It is a fully serviced 8 blocks of 2 bedroom apartments with BQ. The distance from this location to Central area of Abuja is approximately 10 Minutes with surrounding residents being diplomats, middle income earners and business executives. With a limited number of 200 available investment units and counting down,
                  you can Invest from N500,000 for 1 unit and earn 24% of your Investment in 12 Months. You can Invest in as many Investment units as available.</p>
           </div>

           <div class="row">
                    <div class="col-md-4">
                    <p  className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> Living room</p>
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> 3 Bedrooms </p>
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> Networking events</p>
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> Movies and events</p>


                    </div>
                    <div class="col-md-5">
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> Spa Services</p>
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> Car services</p>
                    <p className="hmseconddescription"><img className="img-fluid" src="images/icons/tick-circle.png"/> House keeping/laundry services</p>


                    </div>
                </div>
         </Tab>

         <Tab label="Make Payment">
           <div>
             {/* <p className="">How would you like to make payment?</p> */}
             <div class="col-md-12">
             {/* <div class="row">
                                        <div class="col-md-3">
                                        <p style={{textAlign:"center"}}>    <img style={{marginTop:"20px" }} class="" width="140px" height="140px" src="/images/reit/paymentsteps-01.png" alt=""/></p>

                                        </div>

                                        <div class="col-md-3">
                                            <p style={{textAlign:"center"}}>     <img style={{marginTop:"20px" }}class="imageborder"  width="140px" height="140px"src="/images/reit/paymentsteps-02.png" alt=""/></p>

                                        </div>

                                        <div class="col-md-3">
                                            <p style={{textAlign:"center"}}>     <img style={{marginTop:"20px" }} class="imageborder" width="140px" height="140px"src="/images/reit/paymentsteps-03.png" alt=""/></p>

                                        </div>
                                      
                                    </div>
                                    <p class="centermobileonly">
                                   <button  onClick={showPaystack} class="hmfirstboxbutton3">Pay With Paystack</button>
                                  <button  onClick={showTransfer}  class="hmfirstboxbutton3">Pay Via Transfer</button>
                </p> */}
                                     



           
                <div class="aftersuccess">
                                    <p style={{textAlign:"center",paddingTop:"0px" }}id="paymenttitleoption"></p>
                            
                                     <p style={{textAlign:"center",paddingTop:"0px"}}>PLEASE FILL IN THE FOLLOWING DETAILS.</p>
                                     <p style={{textAlign:"center",paddingTop:"0px", color:"#D80032"}}>Please fill all fields as they are all required.</p>
                                  <div class="row">
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="name" placeholder="Enter Your Fullname" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="email" placeholder="Enter Email Address" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="phone" placeholder="Enter Phone Number" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="address" placeholder="Address" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="nok" placeholder="Next Of Kin Name" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="nokaddress" placeholder="Next Of Kin Address" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="nokphone" placeholder="Next Of Kin Phone Number" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="nokemail" placeholder="Next Of Kin E-mail" required/>
                                     </div>
                            
                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="nokrelationship" placeholder="Next Of Kin Relationship" required/>
                                     </div>

                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="bank" placeholder="Bank" required/>
                                     </div>

                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="accountname" placeholder="Bank Account Name" required/>
                                     </div>

                                     <div class="col-md-4">
                                        <input style={{marginTop: "20px" }} type="" class="form-control" id="accountnumber" placeholder="Bank Account Number" required/>
                                     </div>
                            
                                     <div class="col-md-4"style={{marginTop: "20px" }} >
                                        <select id="UnitDropdownId" name="UnitDropdown"  class="UnitDropdown form-control">
                                            <option value="">- Select No Of Units -</option> 
                                            <option value="1"> 1 </option>              
                                            <option value="2"> 2 </option>    
                                            <option value="3"> 3 </option>    
                                            <option value="4"> 4 </option>    
                                            <option value="5"> 5 </option>    
                                            <option value="6"> 6 </option>    
                                            <option value="7"> 7 </option>    
                                            <option value="8"> 8 </option>    
                                            <option value="9"> 9 </option>    
                                            <option value="10"> 10 </option> 
                                            <option value="11"> 11 </option>              
                                            <option value="12"> 12 </option>    
                                            <option value="13"> 13 </option>    
                                            <option value="14"> 14 </option>    
                                            <option value="15"> 15 </option>    
                                            <option value="16"> 16 </option>    
                                            <option value="17"> 17 </option>    
                                            <option value="18"> 18 </option>    
                                            <option value="19"> 19 </option>    
                                            <option value="20"> 20 </option>                               
                                        </select>
                                     </div>
                                     <div class="col-md-12">
                                        <p style={{textAlign:"center", paddingTop:"15px"}}>Each Investment Unit is &#x20A6;500,000</p>
                                        <p style={{color:"#000",textAlign:"center",}}>Account Name: Rich-Oak Investment and Business Advisory Limited</p>
                                        <p  style={{color:"#000",textAlign:"center",}}>Account Name: Account Number: 5400596135</p>
                                        <p  style={{color:"#000",textAlign:"center",}}>Account Name: Bank Name: Providus bank</p>
                                   {/* <div class="transferbutton">
                                       <div class="row">
                            
                                        <div  class="col-md-4">
                                            <p style={{color:"#000"}}>Account Name: Rich-Oak Investment and Business Advisory Limited</p>
                                        </div>
                            
                                        <div  class="col-md-4">
                                            <p  style={{color:"#000"}}>Account Name: Account Number: 5400596135</p>
                            
                                        </div>
                            
                                        <div  class="col-md-4">
                                            <p  style={{color:"#000"}}>Account Name: Bank Name: Providus bank</p>
                            
                                        </div>
                                       </div>
                                   
                                 
                                    <p style={{textAlign:"center", paddingTop:"30px"}}>Click The Button Below After Making Payment.</p>
                            
                                   </div> */}
                               
                                      </div>
                            
                            
                            
                                      <div class="col-md-12">
                                        <p style={{textAlign:"center", color:"#D80032 "}}class="err" id="err"></p>
                                      {/* <p style="text-align:center" class="paystackbutton"><button style={{marginTop:"10px "}} onclick="payWithPaystack()" class="homecareersbutton">Pay With Paystack</button></p> */}
                                      <p style={{textAlign:"center" }}class="transferbutton"> <button style={{marginTop:"10px "}}  onClick={submitFunction} class="hmfirstboxbutton3">SUBMIT</button></p>
                                        </div>
                            
                            
                            
                            
                            
                            
                              
                                        {/* <div class="modal fade" id="bod1Modal" role="dialog"   data-backdrop="static" data-keyboard="false">
                                            <div class="modal-dialog modal-lg">
                                                <div class="modal-content">
                                                    
                                                    <div class="modal-header">
                                                      
                                                        <h6 style="text-align:center" class="modal-title"></h6>
                                    
                                                    </div>
                                    
                                                    <div class="modal-body">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 modalfirstbody">
                                                    
                              
                                               <div class="">
                                             
                                   
                                                
                                    
                                                
                                                    <p class="investdescription2 sapdescription " style=""> Congratulations, <span id="clientname"></span>       </p>
                                                    <p class="investdescription2 sapdescription " style="padding-top:30px"> We are pleased to confirm that your investment into Oak Grandeur II has been successful. <br/>
                                                 
                                              Kindly download your investment certificate below <br/>
                                                        </p>
                                                 <br/>    
                                                 <p>  Thank you for choosing Rich-Oak.<br/>
                                                        Peace. <br/>
                                                        From Rich-Oak. </p>
                                                           
                                                      <p style="text-align:center">  <a class="paystackbutton" href="/oakgrandeurcertificate#downloadbutton"><button style="margin-top:10px"  class="homecareersbutton">Download Certificate</button></a></p>
                            
                                                                    </div>                            
                                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                    
                                                    <div class="modal-footer">
                                                        <button type="button" onclick="refreshFunction()" class="homecareersbutton btn-small">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                                                     */}
                              
                                        {/* <div class="modal fade" id="bod2Modal" role="dialog"   data-backdrop="static" data-keyboard="false">
                                            <div class="modal-dialog modal-lg">
                                                <div class="modal-content">
                                                    
                                                    <div class="modal-header">

                                                        <h6 style="text-align:center" class="modal-title"></h6>
                                    
                                                    </div>
                                    
                                                    <div class="modal-body">
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12 modalfirstbody">
                                                    
                              
                                               <div class="">
                                             
                                   
                                                
                                    
                                                
                                                    <p class="investdescription2 sapdescription " style=""> Congratulations, <span id="clientname"></span>       </p>
                                                    <p class="investdescription2 sapdescription " style="padding-top:30px"> We are pleased to confirm that your investment into Oak Grandeur II has been successful. <br/>
                                                 
                                               Upon confirmation in 2 hours, you will receive your Investment certificate.<br/>
                                                        </p>
                                                 <br/>    
                                                 <p>  Thank you for choosing Rich-Oak.<br/>
                                                        Peace. <br/>
                                                        From Rich-Oak. </p>
                                                           
                                                      <p style="text-align:center">  <a class="paystackbutton" href="/oakgrandeurcertificate#downloadbutton"><button style="margin-top:10px"  class="homecareersbutton">Download Certificate</button></a></p>
                            
                                                                    </div>                            
                                                                            
                                                            </div>
                                                        </div>
                                                    </div>
                                    
                                                    <div class="modal-footer">
                                                        <button type="button" onclick="refreshFunction()" class="homecareersbutton btn-small">Close</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                        */}
                                                </div>
                              <div class="accountpayable">
                              
                              {/* <p class="investdescription2 sapdescription " style={{textAlign:"center", color:"#D80032"}}>
                              Submitted Successfully      </p> */}
                              
                              {/* <p class="investdescription2 sapdescription " style={{textAlign:"center"}}>
                              You can make payment to this account:     </p>
                                     <p class="investdescription2 sapdescription " style={{textAlign:"center"}}>
                                         Account Name: Rich Oak Investment and Business Advisory Limited        </p>
                                         <p class="investdescription2 sapdescription " style={{textAlign:"center"}}>     Account Number: 5400596135</p>
                                             <p class="investdescription2 sapdescription" style={{textAlign:"center"}}>     Bank Name: Providus bank.           </p>
                                 
                                  */}
                                         </div>       
                              </div>
                                                 
















                                        </div>
           </div>
         </Tab>


         <Tab label="Gallery">
           <div>
           <div class="row">
                                <div class="col-md-4">
                                <div class="item">
                                <div class="polaroid"><img class="img-fluid" width="330" height="225" src="/images/oakgrandeur2/frame1.jpg"/>
                          
                                </div>
                                </div>
                                </div>
                                
                                <div class="col-md-4">
                                <div class="item">
                                <div class="polaroid"><img class="img-fluid"  width="330" height="225"  src="/images/oakgrandeur2/frame2.jpeg"/>            
                                                        
                                </div>
                                </div>
                                </div>
                                
                                <div class="col-md-4">
                                <div class="item">
                                <div class="polaroid"><img class="img-fluid" width="330" height="225"  src="/images/oakgrandeur2/frame3.jpeg"/>
                                                                  
                                </div>
                                </div>
                                </div>

                                <div class="col-md-4" style={{marginTop:"30px"}}>
<div class="item">
<div class="polaroid"><img class="img-fluid"  width="330" height="225"  src="/images/oakgrandeur2/1.jpg"/>
                                    <div class="caption"></div>
</div>
</div>
</div>

<div class="col-md-4" style={{marginTop:"30px"}}>
<div class="item">
<div class="polaroid"><img class="img-fluid"  width="330" height="225"  src="/images/oakgrandeur2/4.jpg"/>
                                   <div class="caption"></div>
</div>
</div>
</div>

<div class="col-md-4" style={{marginTop:"30px"}}>
<div class="item">
<div class="polaroid"><img class="img-fluid"  width="330" height="225"  src="/images/oakgrandeur2/5.jpg"/>
                                   <div class="caption"></div>
</div>
</div>
</div>


                                </div>
           </div>
         </Tab>
  
       </Tabs>
      </div>
                   

               </div>
       
           </div>
       </div>
        </div>
    </div>
    </div>
</div>
</div>

    {/* <div className='fordesktoponly'>
<p className='addspacing70'></p>
</div> */}













{/* <Testimonials/> */}
{/* <Faq/>         */}
<Contact/>








    </div>






    <Footer/>
    </div>


    )
    
    
}


export {Oakgrandeurii  as default}